export const locales = ['en', 'fa'];
export const defaultLocale = 'fa';
export const localeResources = {
    en: {
        common: {
            brand: 'Soroush Airline',
            brandSub: 'International',
            tagline: 'Where every journey begins with quiet luxury.',
            bookNow: 'Book your flight',
            searchFlights: 'Flights',
            manageBooking: 'Manage booking',
            myMiles: 'Soroush Miles',
            login: 'Sign in',
            logout: 'Sign out',
            register: 'Join',
            admin: 'Admin',
            language: 'Language',
            loading: 'Loading…',
            origin: 'From',
            destination: 'To',
            departureDate: 'Departure',
            outboundDate: 'Depart',
            returnDate: 'Return',
            passengers: 'Passengers',
            adults: 'Adults',
            childrenPax: 'Children (2–11)',
            infantsPax: 'Infants (<2)',
            fareOptions: 'Fare options',
            fareOptionLabel: 'Class {{code}}',
            cabin: 'Cabin',
            continue: 'Continue',
            confirm: 'Confirm',
            cancel: 'Cancel',
            pnr: 'Booking reference',
            lastName: 'Last name',
            total: 'Total',
            payNow: 'Pay securely',
            confirmed: 'Confirmed',
            hold: 'On hold',
            errorGeneric: 'Something went wrong. Please try again.',
            exploreDestinations: 'Network',
            destinationsTitle: 'Places we fly',
            destinationsLead: 'From Tehran to Istanbul, Najaf, and cities across Iran — curated routes with quiet luxury.',
            findFlight: 'Search',
            searchingFlights: 'Searching flights',
            changeSearch: 'Change search',
            passengerCount: 'Passengers',
            dateUnavailable: 'Not available',
            oneWay: 'One way',
            roundTrip: 'Round trip',
            multiCity: 'Multi-city',
            buyTicket: 'Buy ticket',
            onlineCheckin: 'Online check-in',
            myTrips: 'My trips',
            checkinLead: 'Online check-in (from 24 hours before departure)',
            bookingOrTicket: 'Booking reference or ticket number',
            checkinFlightNumber: 'Flight number',
            checkinPhone: '+98 21 9100 0000',
            checkinEmail: 'checkin@soroushair.com',
            selectPassengers: 'Passengers',
            adultsAge: '12+ years',
            childrenAge: '2–12 years',
            infantsAge: 'Under 2',
            passengerSummary: '{{count}} passenger',
            passengerSummary_other: '{{count}} passengers',
            addFlight: 'Add flight',
            removeFlight: 'Remove flight',
            originRequired: 'Origin is required',
            destinationRequired: 'Destination is required',
            dateRequired: 'Flight date is required',
            domesticFlights: 'Domestic',
            internationalFlights: 'International',
            addReturnDate: 'Add return date',
            selectDate: 'Select',
            jalaliCalendar: 'Solar calendar',
            gregorianCalendar: 'Gregorian calendar',
            switchToGregorian: 'Switch to Gregorian',
            switchToJalali: 'Switch to Solar',
            close: 'Close',
            closeCalendar: 'Close calendar',
            stepServices: 'More services',
            servicesTitle: 'Included with your ticket',
            servicesLead: 'Baggage and fare rules for the flights you selected. Seat selection opens with online check-in.',
            servicesCheckinNote: 'Online check-in, including seat selection, opens 24 hours before departure.',
            continueToReview: 'Continue to review',
            nextFlight: 'Book the next flight',
            loginToSeeTrips: 'Sign in to see upcoming trips',
            tripsLastName: 'Passenger last name (Latin)',
            tripsLookupLead: 'Or look up a booking without signing in.',
            economy: 'Economy',
            premium_economy: 'Premium economy',
            business: 'Business',
            first: 'First',
            from: 'From',
            viewAll: 'View all',
            footerRights: '© {{year}} Soroush Airline. All rights reserved.',
            footerTravel: 'Travel',
            footerAccount: 'Account',
            footerSupport: 'Support',
            footerContact: 'Contact',
            footerAboutLead: 'Quiet luxury across our curated network — from Tehran to the cities that matter.',
            footerHelpCenter: 'Help & assistance',
            footerBaggage: 'Baggage information',
            footerPrivacy: 'Privacy',
            footerTerms: 'Terms of carriage',
            footerEmail: 'travel@soroushair.com',
            footerPhone: '+98 21 9100 0000',
            footerHq: 'Tehran, Iran',
            retrieveBooking: 'Retrieve booking',
            cabinClass: 'Cabin class',
            seatsLeft: 'seats left',
            selectFlight: 'Select flight',
            noResults: 'No flights found for these dates.',
            outboundFlight: 'Outbound',
            returnFlight: 'Return',
            selectOutbound: 'Select your outbound flight',
            selectReturn: 'Select your return flight',
            changeFlight: 'Change',
            noReturnResults: 'No return flights found for this date.',
            returnTooEarly: 'Return flights on this date leave before your outbound arrives.',
            pickOutboundFirst: 'Choose your outbound flight to continue.',
            roundTripNote: 'Each direction is issued as its own ticket.',
            payReturn: 'Pay for the return flight',
            payOutboundAmount: 'Pay outbound · {{amount}}',
            payReturnAmount: 'Pay return · {{amount}}',
            roundTripPayNote: 'The return flight is paid in the next step.',
            returnHeld: 'The return flight is held separately. Complete its payment to issue that ticket.',
            flightOpen: 'On sale',
            flightClosed: 'Closed',
            soldOut: 'Sold out',
            fareNotSet: 'Price not announced',
            perPassenger: 'per passenger',
            flightN: 'Flight {{n}}',
            flightDuration: '{{h}}h {{m}}m',
            bookingProgress: 'Booking progress',
            stepSelectFlight: 'Select flight',
            stepPassengers: 'Passenger details',
            stepReview: 'Review & pay',
            stepPayment: 'Review & pay',
            stepTicket: 'Ticket issued',
            passengerN: 'Passenger {{n}}',
            adult: 'Adult',
            firstNameLatin: 'First name (Latin)',
            lastNameLatin: 'Last name (Latin)',
            gender: 'Gender',
            male: 'Male',
            female: 'Female',
            birthDate: 'Date of birth',
            day: 'Day',
            month: 'Month',
            year: 'Year',
            nationality: 'Nationality',
            iranian: 'Iranian',
            nonIranian: 'Non-Iranian',
            nationalCode: 'National ID',
            passportNumber: 'Passport number',
            passportExpiry: 'Passport expiry',
            passportCountry: 'Passport country code (e.g. TR)',
            contactInfo: 'Contact details',
            nameAsOnDocument: 'Enter the name in Latin letters, exactly as it appears on the travel document.',
            personalDetails: 'Personal details',
            travelDocument: 'Travel document',
            contactHint: 'The ticket and flight messages are sent to these details.',
            selectPlaceholder: 'Select',
            mobile: 'Mobile number',
            email: 'Email',
            latinOnly: 'Use English letters only.',
            invalidNationalCode: 'National ID is not valid.',
            invalidMobile: 'Enter a valid mobile number, e.g. 09121234567.',
            invalidCountry: 'Enter a 2-letter country code.',
            requiredField: 'This field is required.',
            fixErrors: 'Please correct the highlighted fields.',
            flightDetails: 'Flight details',
            priceDetails: 'Price details',
            passengersCount: '{{count}} passenger(s)',
            totalPayable: 'Total payable',
            editPassengers: 'Edit passengers',
            acceptTerms: 'I accept the terms of carriage and refund rules.',
            confirmAndPay: 'Confirm and pay',
            back: 'Back',
            flightNumber: 'Flight number',
            fullName: 'Full name',
            taxesIncluded: 'Incl. taxes and fees',
            outboundTicketIssued: 'Your outbound ticket has been issued',
            ticketIssued: 'Your ticket has been issued',
            ticketIssuedLead: 'A confirmation has been sent to {{email}}.',
            paymentFailed: 'Payment was not completed. Your seats are held until {{time}}.',
            paymentFailedExpired: 'Payment was not completed and the hold has expired.',
            retryPayment: 'Pay again',
            ticketNumber: 'Ticket number',
            document: 'Document',
            printTicket: 'Print ticket',
            newSearch: 'New search',
            amountPaid: 'Amount paid',
            primaryNav: 'Primary',
            openMenu: 'Open menu',
            closeMenu: 'Close menu',
            swapRoute: 'Swap origin and destination',
            originCity: 'From (city)',
            destinationCity: 'To (city)',
            searchCity: 'Search city or code',
            noCityResults: 'No cities match your search.',
            calendarToday: 'Today',
            calendarPrevMonth: 'Previous month',
            calendarNextMonth: 'Next month',
            child: 'Child',
            infant: 'Infant',
            refundable: 'Refundable',
            nonRefundable: 'Non-refundable',
            fareClass: 'Fare class',
            baggage: 'Baggage allowance',
            refundRules: 'Cancellation penalties',
            fareChecking: 'Checking the fare with the airline…',
            fareUnavailable: 'This fare is no longer available. Please choose another flight.',
            mixNoAdult: 'At least one adult (12 years or older) must travel.',
            mixTooManyInfants: 'Each infant must travel with their own adult.',
            mixTooManyDependants: 'Each adult can travel with at most 4 children and infants.',
            priceChanged: 'The airline price changed from {{old}} to {{amount}}.',
            payNewPrice: 'Continue and pay {{amount}}',
            airlineReference: 'Airline reference',
            ticketing: 'Payment received. Issuing your ticket…',
            ticketingLead: 'This usually takes less than a minute. You can keep this page open.',
            ticketingDelayed: 'Issuing your ticket is taking longer than usual. Our team is on it and will email {{email}}.',
            refundNotice: 'Your payment was received but the booking could not be completed. The full amount will be refunded to your card.',
            bookingCancelled: 'This booking is cancelled.',
            bookingStatus: {
                HOLD: 'On hold',
                TICKETING: 'Issuing ticket',
                CONFIRMED: 'Confirmed',
                CANCELLED: 'Cancelled',
                EXPIRED: 'Expired',
                COMPLETED: 'Completed',
            },
            nrsReasons: {
                CLASS_CLOSED: 'This fare has just sold out. Please choose another flight.',
                FOREIGN_NATIONAL_CLASS: 'This fare is reserved for foreign nationals.',
                INVALID_DOCUMENT: 'The airline did not accept a passenger document. Check the national ID or passport details.',
                INVALID_NAME: 'The airline did not accept a passenger name. Use Latin letters as written in the passport.',
                INVALID_CONTACT: 'The airline did not accept the mobile number.',
                PASSENGER_MIX: 'Children and infants must travel with an adult.',
                PASSENGER_NOT_ALLOWED: 'The airline does not accept one of the passengers on this flight.',
                PNR_CANCELLED: 'The reservation was cancelled by the airline.',
                PRICE_MISMATCH: 'The price changed at the airline. Please search again.',
                OTHER: 'The airline did not accept this booking. Please try another flight.',
            },
            apiErrors: {
                NRS_UNAVAILABLE: 'The airline system is not reachable right now. Please try again in a few minutes.',
                FLIGHT_CHANGED: 'The flight time has changed. Please search again.',
                RATE_LIMITED: 'Too many attempts. Please wait a few minutes and try again.',
                VALIDATION_ERROR: 'Some passenger details are not valid. Please check them.',
            },
        },
        nav: {
            login: 'Login / Register',
            missing: 'This page could not be found.',
            groups: {
                book: 'Book',
                travelInfo: 'Travel information',
                inflight: 'In flight',
                destinations: 'Destinations',
            },
            items: {
                buyTicket: 'Buy ticket',
                checkin: 'Online check-in',
                refund: 'Refund ticket',
                change: 'Change ticket',
                transfer: 'Airport transfer',
                buyGuide: 'Ticket purchase guide',
                manageGuide: 'Booking management guide',
                refundGuide: 'Ticket refund guide',
                checkinGuide: 'Passenger check-in guide',
                reduced: 'Passengers with reduced mobility',
                medical: 'Medical cases',
                minor: 'Unaccompanied minor',
                meals: 'Special meals',
                lounge: 'Lounge services',
                requirements: 'Travel requirements',
                baggage: 'Baggage',
                dangerous: 'Prohibited and dangerous goods',
                animals: 'Live animals',
                lost: 'Lost baggage',
                safety: 'Flight safety and security',
                fleet: 'Soroush fleet',
                seats: 'Seat map',
                cabins: 'Cabin classes',
                crew: 'Cabin crew',
                dining: 'Dining',
                entertainment: 'In-flight entertainment',
                magazine: 'In-flight magazine',
                domestic: 'Domestic destinations',
                international: 'International destinations',
                tourism: 'Travel with Soroush',
                club: 'Loyalty club',
            },
            leads: {
                refund: 'Find the booking with the reservation code and last name to continue a refund.',
                change: 'Find the booking with the reservation code and last name to continue a change.',
            },
            copy: {
                transfer: 'Airport transfer can be arranged before departure on selected international and business journeys.',
                buyGuide: 'Search a route, choose a flight, and enter the passenger details. Secure payment issues the ticket.',
                manageGuide: 'Look up a booking with the reservation code and last name to review its status.',
                refundGuide: 'A refund starts from the reservation code and last name. Penalties follow the fare rules.',
                checkinGuide: 'Online check-in opens 24 hours before departure. You need the reservation code, last name, and flight number.',
                reduced: 'Passengers who need a wheelchair or help at the airport can request it before travel.',
                medical: 'Needs such as oxygen or a stretcher must be arranged with the airline before the ticket is issued.',
                minor: 'An unaccompanied child travels with guardian consent and is handed over at both airports.',
                meals: 'Request a special meal when you book, or at least 24 hours before departure.',
                lounge: 'Lounge access is available for business class and club members at selected airports.',
                requirements: 'Visas and entry rules belong to the passenger. Check the destination before you fly.',
                baggage: 'The free allowance depends on the cabin and the fare. Extra baggage is charged at the airport.',
                dangerous: 'Liquids, batteries, and dangerous goods may be restricted in the cabin or in checked baggage.',
                animals: 'Live animals are accepted only with advance notice and an approved crate.',
                lost: 'If a bag does not arrive, report it the same day at the airport baggage desk and keep the reservation code.',
                safety: 'Seat belts, emergency exits, and crew instructions are the basis of safety on board.',
                fleet: 'The Soroush fleet operates the airline’s domestic and international network.',
                seats: 'Seat layout depends on the aircraft. Seat selection opens with online check-in.',
                cabins: 'Economy and business differ in baggage, dining, and personal space.',
                crew: 'Cabin crew look after safety and service during the flight.',
                dining: 'Meals follow the length of the flight and the cabin you booked.',
                entertainment: 'In-flight entertainment is available on selected routes.',
                magazine: 'The Soroush in-flight magazine is offered on selected flights.',
                tourism: 'Journey ideas across the Soroush domestic and international network.',
                domestic: 'Cities Soroush flies to inside Iran.',
                international: 'Cities Soroush flies to beyond Iran.',
                club: 'The loyalty club keeps your miles, tier, and membership number.',
            },
        },
        fleet: {
            specsTitle: 'Technical specifications',
            specs: {
                mtow: 'Maximum takeoff weight',
                range: 'Maximum range',
                wingspan: 'Wingspan',
                length: 'Aircraft length',
                height: 'Aircraft height',
                passengers: 'Passenger capacity',
            },
            units: {
                kg: 'kg',
                km: 'km',
                m: 'm',
                pax: 'passengers',
            },
            a300: {
                name: 'Airbus A300-600',
            },
            a310: {
                name: 'Airbus A310',
            },
        },
        club: {
            eyebrow: 'Soroush Club',
            title: 'Your membership',
            lead: 'Miles, tier, and the passenger details we use when you fly.',
            member: 'Member',
            awardMiles: 'Award miles',
            lifetime: 'Lifetime',
            statusMiles: 'Status miles',
            segments: 'Sectors',
            tierUntil: 'Tier reviewed {{date}}',
            milesToNext: '{{miles}} miles to {{tier}}',
            topTier: 'You are on the highest tier',
            benefits: {
                BLUE: 'Earn miles on every Soroush flight you fly.',
                SILVER: 'Priority check-in once you reach Silver.',
                GOLD: 'Extra baggage and lounge access at selected airports.',
                PLATINUM: 'Dedicated service and the highest recognition on the ground.',
            },
            completeTitle: 'Add your travel documents',
            completeLead: 'These passenger details are kept in the club and filled in on your next booking.',
            completeAction: 'Complete profile',
            profile: 'Passenger profile',
            edit: 'Edit',
            save: 'Save profile',
            upcoming: 'Upcoming flights',
            past: 'Flight history',
            activity: 'Miles activity',
            emptyFlights: 'No flights yet. A booking made while you are signed in appears here.',
            emptyActivity: 'Miles post here after a ticket is issued.',
            noMiles: 'Miles post after the ticket is issued.',
            signInLead: 'Sign in to see your miles, tier, and trips.',
            landing: {
                heroEyebrow: 'Soroush Loyal Passengers Club',
                heroTitle: 'Join Soroush Club and fly with recognition',
                heroLead: 'Membership unlocks miles on every Soroush flight, tier benefits on the ground, and a clearer path to Silver, Gold, and Platinum.',
                joinCta: 'Join / Sign in',
                seeBenefits: 'View benefits',
                welcomeTitle: 'Miles that remember every journey',
                welcomeLead: 'Open your account once — then earn, track, and redeem as you fly with us.',
                tiersTitle: 'Membership tiers',
                tiersLead: 'Soroush Club tiers are designed around how often you fly with us: Blue, Silver, Gold, and Platinum — each with services matched to your companionship.',
                tiersVisualAlt: 'Soroush Club membership cards for Blue, Silver, Gold, and Platinum',
                fromMiles: 'From {{miles}} miles',
                tierNames: {
                    BLUE: 'Blue',
                    SILVER: 'Silver',
                    GOLD: 'Gold',
                    PLATINUM: 'Platinum',
                },
                servicesTitle: 'Club services',
                services: {
                    miles: {
                        title: 'Earn & redeem miles',
                        lead: 'Collect award miles on Soroush flights and use them toward future travel.',
                    },
                    baggage: {
                        title: 'Extra baggage',
                        lead: 'Higher tiers unlock additional baggage allowance on selected routes.',
                    },
                    lounge: {
                        title: 'Lounge access',
                        lead: 'Gold and Platinum members enjoy lounge access at selected airports.',
                    },
                    priority: {
                        title: 'Priority on the ground',
                        lead: 'Faster check-in and dedicated recognition as your tier rises.',
                    },
                },
                finalTitle: 'Ready to start earning?',
                finalLead: 'Create your membership or sign in to see miles, tier progress, and trips.',
            },
            localFirstName: 'First name in Persian',
            localLastName: 'Last name in Persian',
            homeAirport: 'Home airport',
            invalidAirport: 'Enter a 3-letter airport code.',
            seat: 'Seat preference',
            meal: 'Meal',
            assistance: 'Special assistance',
            assistanceNone: 'None',
            emergency: 'Emergency contact',
            emergencyName: 'Name',
            emergencyPhone: 'Phone',
            emergencyRelation: 'Relationship',
            marketing: 'Email me club news and offers',
            preferences: 'Travel preferences',
            documents: 'Documents',
            contact: 'Sign-in details',
            contactHint: 'You can sign in with either of these.',
            reasons: { FLIGHT_EARN: 'Flight' },
            seats: { ANY: 'No preference', WINDOW: 'Window', AISLE: 'Aisle' },
            meals: {
                STANDARD: 'Standard',
                VEGETARIAN: 'Vegetarian',
                HALAL: 'Halal',
                KOSHER: 'Kosher',
                CHILD: 'Child',
            },
            assistanceCodes: {
                WCHR: 'Wheelchair to the gate',
                WCHS: 'Wheelchair on steps',
                WCHC: 'Wheelchair to the seat',
                DEAF: 'Deaf passenger',
                BLND: 'Blind passenger',
                MAAS: 'Meet and assist',
            },
            status: {
                HOLD: 'On hold',
                TICKETING: 'Ticketing',
                CONFIRMED: 'Confirmed',
                CANCELLED: 'Cancelled',
                COMPLETED: 'Flown',
                EXPIRED: 'Expired',
            },
        },
        auth: {
            welcome: 'Welcome',
            welcomeLead: 'Sign in with your mobile number or email. If you do not have an account yet, you can register here.',
            email: 'Email',
            identifier: 'Mobile or email',
            invalidIdentifier: 'Enter a mobile number or email.',
            password: 'Password',
            passwordHint: 'At least 10 characters, with upper and lower case, a number, and a symbol.',
            firstName: 'First name',
            latinHint: 'As it appears on your passport or ID, in English letters.',
            altEmail: 'Email (optional)',
            altMobile: 'Mobile (optional)',
            otherContact: 'Add the other one too, and you can sign in with either.',
            needContact: 'Enter a mobile number or an email address.',
            noAccount: 'New here?',
            hasAccount: 'Already a member?',
            signIn: 'Sign in',
            join: 'Join',
        },
        admin: {
            brand: 'Soroush',
            console: 'Admin Console',
            rial: 'IRR',
            empty: 'Nothing to show yet.',
            nav: {
                dashboard: 'Dashboard',
                flights: 'Flights',
                routeFares: 'Route fares',
                bookings: 'Bookings',
                users: 'Users',
                audit: 'Audit',
                nrsRest: 'NRS fares',
                signOut: 'Sign out',
            },
            login: {
                email: 'Email',
                password: 'Password',
                signIn: 'Sign in',
                roleRequired: 'This account does not have admin access.',
                invalidCredentials: 'Email or password is incorrect.',
            },
            dashboard: {
                title: 'Operations dashboard',
                integrations: 'Integrations',
                nira: 'Nira service',
                paymentGateway: 'Payment gateway',
                connected: 'Connected',
                notConnected: 'Not reachable',
                notConfigured: 'Not configured',
                configured: 'Configured',
                nrs: 'NRS reservation system',
                nrsSales: 'Live NRS sales',
                nrsCredit: 'Office credit',
                nrsBlocked: 'Blocked',
                nrsRest: 'NRS REST API (FareQuote / MultiSeg)',
                salesOn: 'On',
                salesOff: 'Off (schedule and route fares)',
                stats: {
                    bookings: 'All bookings',
                    completedPayments: 'Completed payments',
                    users: 'Users',
                    activeFlights: 'Active flights',
                    holds: 'Awaiting payment',
                    confirmed: 'Confirmed bookings',
                    ticketing: 'Paid, awaiting ticket',
                    refundPending: 'Refunds to pay out',
                },
                gateways: {
                    MOCK: 'Test (mock)',
                    SAMAN: 'Saman',
                },
            },
            flights: {
                title: 'Flights',
                flightNumber: 'Flight number',
                origin: 'Origin',
                destination: 'Destination',
                departure: 'Departure',
                create: 'Create flight',
                flight: 'Flight',
                route: 'Route',
                status: 'Status',
            },
            routeFares: {
                title: 'Route fares',
                lead: 'Price and seats per flight for routes from the NRS schedule. Used until NRS provides live fares and availability.',
                origin: 'Origin',
                destination: 'Destination',
                cabin: 'Cabin',
                baseFare: 'Base fare (IRR)',
                taxes: 'Taxes (IRR)',
                seatsPerFlight: 'Seats per flight',
                onSale: 'On sale',
                off: 'Off',
                save: 'Save fare',
                saving: 'Saving…',
                unpriced: 'Routes on sale without a fare:',
                route: 'Route',
                baseFareShort: 'Base fare',
                taxesShort: 'Taxes',
                total: 'Total',
                seats: 'Seats / flight',
                status: 'Status',
                edit: 'Edit',
                delete: 'Delete',
            },
            bookings: {
                title: 'Bookings',
                pnr: 'PNR',
                status: 'Status',
                total: 'Total',
                email: 'Email',
                airlinePnr: 'Airline PNR',
                flight: 'Flight',
                created: 'Created',
                search: 'PNR, airline PNR, email or ticket number',
                searchButton: 'Search',
                open: 'Details',
            },
            bookingDetail: {
                back: 'All bookings',
                title: 'Booking {{pnr}}',
                summary: 'Summary',
                source: 'Source',
                sources: { local: 'Local inventory', nrs: 'NRS (live)' },
                contact: 'Contact',
                flight: 'Flight',
                fareClass: 'Fare class',
                baggage: 'Baggage',
                refundable: 'Refundable',
                yes: 'Yes',
                no: 'No',
                holdUntil: 'Hold expires',
                passengers: 'Passengers',
                name: 'Name',
                type: 'Type',
                document: 'Document',
                ticket: 'Ticket',
                passengerTypes: { ADT: 'Adult', CHD: 'Child', INF: 'Infant' },
                payments: 'Payments',
                amount: 'Amount',
                refundAmount: 'Refund due',
                paidAt: 'Paid at',
                gateway: 'Gateway',
                note: 'Note',
                ticketing: 'Ticketing',
                attempts: 'Attempts',
                lastError: 'Last error',
                nextAttempt: 'Next automatic attempt',
                manual: 'Needs manual action',
                issueNow: 'Issue tickets now',
                abandon: 'Cancel PNR and refund',
                abandonConfirm: 'Cancel the airline PNR and mark the payment for refund?',
                airline: 'Live airline record',
                loadAirline: 'Load PNR and tickets from NRS',
                pnrStatus: 'PNR status',
                airlineTotal: 'Airline total',
                coupons: 'Coupons',
                refund: 'Refund',
                previewPenalty: 'Check penalties',
                penaltyNow: 'Penalty now',
                refundNow: 'Refund now',
                maxPenalty: 'Maximum penalty',
                skipSeatCancel: 'Seats were already released (after check-in closed)',
                refundSelected: 'Refund selected passengers',
                refundConfirm: 'Cancel the seats and refund the selected tickets at the airline? This cannot be undone.',
                refundDone: 'Refund recorded at the airline: {{amount}}. Pay the customer back from the gateway panel.',
                refunded: 'Refunded',
                refundedAmount: 'Refunded amount',
                penalty: 'Penalty',
                working: 'Working…',
            },
            paymentStatus: {
                PENDING: 'Pending',
                REDIRECTED: 'At gateway',
                COMPLETED: 'Paid',
                FAILED: 'Failed',
                REFUND_PENDING: 'Refund pending',
                REFUNDED: 'Refunded',
            },
            users: {
                title: 'Users',
                email: 'Email',
                name: 'Name',
                role: 'Role',
                active: 'Active',
                yes: 'Yes',
                no: 'No',
            },
            nrsRest: {
                title: 'NRS fares and availability',
                lead: 'Read-only checks against the NRS REST API: multi-segment availability with prices (MultiSegAYFare) and the exact quote for chosen flights (FareQuote). Amounts are shown exactly as NRS returns them.',
                availabilityTitle: 'Multi-segment availability',
                quoteTitle: 'Fare quote',
                origin: 'From',
                destination: 'To',
                date: 'Date',
                flightClass: 'Class',
                flightNo: 'Flight no.',
                adults: 'Adults',
                children: 'Children',
                infants: 'Infants',
                includePrice: 'Include prices',
                currency: 'Currency (optional)',
                discountCode: 'Discount code',
                salesDate: 'Sales date (RC/FSP only)',
                addSegment: 'Add segment',
                removeSegment: 'Remove',
                search: 'Search',
                quote: 'Get quote',
                running: 'Working…',
                noItineraries: 'No itineraries found.',
                unpriced: 'Available, fare not calculated',
                connection: 'Connection',
                cabin: 'Cabin',
                bookingClasses: 'Booking classes',
                passenger: 'Passenger',
                fare: 'Fare',
                taxes: 'Taxes',
                total: 'Total',
                baggage: 'Baggage',
                coupon: 'Segment',
                premium: 'P = premium economy',
            },
            audit: {
                title: 'Audit log',
                action: 'Action',
                resource: 'Resource',
                result: 'Result',
                when: 'When',
                ok: 'OK',
                fail: 'Failed',
            },
            cabins: {
                economy: 'Economy',
                premium_economy: 'Premium economy',
                business: 'Business',
                first: 'First',
            },
            bookingStatus: {
                HOLD: 'Awaiting payment',
                TICKETING: 'Paid, issuing ticket',
                CONFIRMED: 'Confirmed',
                CANCELLED: 'Cancelled',
                COMPLETED: 'Completed',
                EXPIRED: 'Expired',
            },
            flightStatus: {
                SCHEDULED: 'Scheduled',
                BOARDING: 'Boarding',
                DEPARTED: 'Departed',
                ARRIVED: 'Arrived',
                CANCELLED: 'Cancelled',
                DELAYED: 'Delayed',
            },
            roles: {
                customer: 'Customer',
                admin: 'Admin',
                superadmin: 'Super admin',
            },
            actions: {
                LOGIN: 'Sign in',
                LOGIN_FAILED: 'Failed sign in',
                LOGOUT: 'Sign out',
                REGISTER: 'Registration',
                CREATE: 'Create',
                UPDATE: 'Update',
                DELETE: 'Delete',
                PAYMENT: 'Payment',
                RECONCILE: 'Reconcile',
            },
            resources: {
                airport: 'Airport',
                booking: 'Booking',
                flight: 'Flight',
                payment: 'Payment',
                routeFare: 'Route fare',
                user: 'User',
            },
            errors: {
                UNAUTHORIZED: 'Your session has ended. Please sign in again.',
                FORBIDDEN: 'You do not have access to this section.',
                NOT_FOUND: 'The requested item was not found.',
                CONFLICT: 'This conflicts with existing data.',
                VALIDATION_ERROR: 'Some of the entered values are not valid.',
                RATE_LIMITED: 'Too many requests. Please try again shortly.',
                NRS_REJECTED: 'The airline rejected the request.',
                NRS_UNAVAILABLE: 'The airline system is not reachable right now.',
                NRS_REFUND_INCOMPLETE: 'The refund stopped partway. Check the passengers below.',
                NRS_TICKET_MISMATCH: 'Tickets did not match the passengers. Check the PNR in NRS.',
                NRS_PASSENGER_NOT_FOUND: 'A passenger was not found in the airline PNR.',
                FLIGHT_CHANGED: 'The flight time changed at the airline.',
                generic: 'Something went wrong. Please try again.',
            },
        },
    },
    fa: {
        common: {
            brand: 'هواپیمایی سروش',
            brandSub: 'بین‌المللی',
            tagline: 'آغاز هر سفر، با آرامشی متفاوت.',
            bookNow: 'رزرو پرواز',
            searchFlights: 'بلیط هواپیما',
            manageBooking: 'سفرهای من',
            myMiles: 'مایل‌های سروش',
            login: 'ورود | ثبت‌نام',
            logout: 'خروج',
            register: 'عضویت',
            admin: 'مدیریت',
            language: 'زبان',
            loading: 'در حال بارگذاری…',
            origin: 'مبدا',
            destination: 'مقصد',
            departureDate: 'تاریخ پرواز',
            outboundDate: 'تاریخ رفت',
            returnDate: 'تاریخ برگشت',
            passengers: 'مسافران',
            adults: 'بزرگسال',
            childrenPax: 'کودک (۲ تا ۱۱ سال)',
            infantsPax: 'نوزاد (زیر ۲ سال)',
            fareOptions: 'گزینه‌های نرخ',
            fareOptionLabel: 'کلاس {{code}}',
            cabin: 'کلاس',
            continue: 'ادامه',
            confirm: 'تایید',
            cancel: 'لغو',
            pnr: 'کد رزرو',
            lastName: 'نام خانوادگی',
            total: 'مجموع',
            payNow: 'پرداخت امن',
            confirmed: 'تایید شده',
            hold: 'رزرو موقت',
            errorGeneric: 'خطایی رخ داد. دوباره تلاش کنید.',
            exploreDestinations: 'مقاصد محبوب',
            destinationsTitle: 'کجا می‌روید؟',
            destinationsLead: 'از تهران تا استانبول، نجف و شهرهای ایران — مسیرهایی منتخب با آرامشی متفاوت.',
            findFlight: 'جستجو',
            searchingFlights: 'در حال جستجوی پروازها',
            changeSearch: 'تغییر جستجو',
            passengerCount: 'تعداد مسافر',
            dateUnavailable: 'موجود نیست',
            oneWay: 'یک طرفه',
            roundTrip: 'رفت و برگشت',
            multiCity: 'چند مسیره',
            buyTicket: 'خرید بلیت',
            onlineCheckin: 'پذیرش آنلاین',
            myTrips: 'سفرهای من',
            checkinLead: 'پذیرش آنلاین (۲۴ ساعت قبل از پرواز)',
            bookingOrTicket: 'شماره رزرو یا شماره بلیت',
            checkinFlightNumber: 'شماره پرواز',
            checkinPhone: '۰۲۱ ۹۱۰۰ ۰۰۰۰',
            checkinEmail: 'checkin@soroushair.com',
            selectPassengers: 'انتخاب تعداد مسافران',
            adultsAge: '+۱۲ سال',
            childrenAge: '۲ تا ۱۲ سال',
            infantsAge: 'زیر ۲ سال',
            passengerSummary: '{{count}} مسافر',
            addFlight: 'افزودن پرواز',
            removeFlight: 'حذف پرواز',
            originRequired: 'مبدا الزامی است',
            destinationRequired: 'مقصد الزامی است',
            dateRequired: 'تاریخ پرواز الزامی است',
            domesticFlights: 'پرواز داخلی',
            internationalFlights: 'پرواز بین‌المللی',
            addReturnDate: 'افزودن تاریخ برگشت',
            selectDate: 'انتخاب',
            jalaliCalendar: 'تقویم شمسی',
            gregorianCalendar: 'تقویم میلادی',
            switchToGregorian: 'تغییر به میلادی',
            switchToJalali: 'تغییر به شمسی',
            close: 'بستن',
            closeCalendar: 'بستن تقویم',
            stepServices: 'خدمات بیشتر',
            servicesTitle: 'خدمات همراه بلیت',
            servicesLead: 'بار مجاز و قوانین نرخ پروازهای انتخاب‌شده. انتخاب صندلی با پذیرش آنلاین باز می‌شود.',
            servicesCheckinNote: 'پذیرش آنلاین و انتخاب صندلی از ۲۴ ساعت قبل از پرواز فعال می‌شود.',
            continueToReview: 'ادامه و بررسی',
            nextFlight: 'رزرو پرواز بعدی',
            loginToSeeTrips: 'برای دیدن سفرهای پیش رو وارد شوید',
            tripsLastName: 'نام خانوادگی (لاتین) مسافر',
            tripsLookupLead: 'یا بدون ورود، رزرو را پیگیری کنید.',
            economy: 'اکونومی',
            premium_economy: 'پریمیوم اکونومی',
            business: 'بیزینس',
            first: 'درجه یک',
            from: 'از',
            viewAll: 'مشاهده همه',
            footerRights: '© {{year}} هواپیمایی سروش. تمامی حقوق محفوظ است.',
            footerTravel: 'سفر',
            footerAccount: 'حساب کاربری',
            footerSupport: 'پشتیبانی',
            footerContact: 'تماس',
            footerAboutLead: 'آرامشی متمایز در شبکه پروازی منتخب — از تهران تا مقاصدی که اهمیت دارند.',
            footerHelpCenter: 'راهنما و پشتیبانی',
            footerBaggage: 'اطلاعات بار',
            footerPrivacy: 'حریم خصوصی',
            footerTerms: 'شرایط حمل',
            footerEmail: 'travel@soroushair.com',
            footerPhone: '۰۲۱۹۱۰۰۰۰۰۰',
            footerHq: 'تهران، ایران',
            retrieveBooking: 'پیگیری رزرو',
            cabinClass: 'کلاس پروازی',
            seatsLeft: 'صندلی باقی‌مانده',
            selectFlight: 'انتخاب پرواز',
            noResults: 'پروازی برای این تاریخ یافت نشد.',
            outboundFlight: 'پرواز رفت',
            returnFlight: 'پرواز برگشت',
            selectOutbound: 'پرواز رفت را انتخاب کنید',
            selectReturn: 'پرواز برگشت را انتخاب کنید',
            changeFlight: 'تغییر',
            noReturnResults: 'برای تاریخ برگشت پروازی پیدا نشد.',
            returnTooEarly: 'پروازهای این تاریخ برگشت، پیش از رسیدن پرواز رفت حرکت می‌کنند.',
            pickOutboundFirst: 'برای ادامه، ابتدا پرواز رفت را انتخاب کنید.',
            roundTripNote: 'هر مسیر بلیط جداگانه دارد.',
            payReturn: 'پرداخت پرواز برگشت',
            payOutboundAmount: 'پرداخت رفت · {{amount}}',
            payReturnAmount: 'پرداخت برگشت · {{amount}}',
            roundTripPayNote: 'پرداخت پرواز برگشت در مرحله بعد انجام می‌شود.',
            returnHeld: 'پرواز برگشت جداگانه رزرو موقت شده است. برای صدور بلیت، پرداخت آن را کامل کنید.',
            flightOpen: 'قابل فروش',
            flightClosed: 'بسته',
            soldOut: 'تکمیل ظرفیت',
            fareNotSet: 'قیمت اعلام نشده',
            perPassenger: 'برای هر مسافر',
            flightN: 'پرواز {{n}}',
            flightDuration: '{{h}} ساعت و {{m}} دقیقه',
            bookingProgress: 'مراحل خرید',
            stepSelectFlight: 'انتخاب پرواز',
            stepPassengers: 'مشخصات مسافران',
            stepReview: 'تایید و پرداخت',
            stepPayment: 'تایید و پرداخت',
            stepTicket: 'صدور بلیت',
            passengerN: 'مسافر {{n}}',
            adult: 'بزرگسال',
            firstNameLatin: 'نام (لاتین)',
            lastNameLatin: 'نام خانوادگی (لاتین)',
            gender: 'جنسیت',
            male: 'مرد',
            female: 'زن',
            birthDate: 'تاریخ تولد',
            day: 'روز',
            month: 'ماه',
            year: 'سال',
            nationality: 'ملیت',
            iranian: 'ایرانی',
            nonIranian: 'غیر ایرانی',
            nationalCode: 'کد ملی',
            passportNumber: 'شماره گذرنامه',
            passportExpiry: 'تاریخ انقضای گذرنامه',
            passportCountry: 'کد کشور صادرکننده گذرنامه (مثلاً TR)',
            contactInfo: 'اطلاعات تماس',
            nameAsOnDocument: 'نام را دقیقاً مطابق مدرک سفر و با حروف لاتین وارد کنید.',
            personalDetails: 'مشخصات فردی',
            travelDocument: 'مدرک سفر',
            contactHint: 'بلیت و پیام‌های پرواز به این مشخصات ارسال می‌شود.',
            selectPlaceholder: 'انتخاب کنید',
            mobile: 'شماره موبایل',
            email: 'ایمیل',
            latinOnly: 'فقط حروف انگلیسی وارد کنید.',
            invalidNationalCode: 'کد ملی معتبر نیست.',
            invalidMobile: 'شماره موبایل معتبر وارد کنید، مثلاً ۰۹۱۲۱۲۳۴۵۶۷.',
            invalidCountry: 'کد دوحرفی کشور را وارد کنید.',
            requiredField: 'این فیلد الزامی است.',
            fixErrors: 'لطفاً فیلدهای مشخص‌شده را اصلاح کنید.',
            flightDetails: 'اطلاعات پرواز',
            priceDetails: 'جزئیات قیمت',
            passengersCount: '{{count}} مسافر',
            totalPayable: 'مبلغ قابل پرداخت',
            editPassengers: 'ویرایش مسافران',
            acceptTerms: 'قوانین حمل و استرداد را می‌پذیرم.',
            confirmAndPay: 'تایید و پرداخت',
            back: 'بازگشت',
            flightNumber: 'شماره پرواز',
            fullName: 'نام و نام خانوادگی',
            taxesIncluded: 'شامل مالیات و عوارض',
            outboundTicketIssued: 'بلیت پرواز رفت صادر شد',
            ticketIssued: 'بلیت شما صادر شد',
            ticketIssuedLead: 'تاییدیه به {{email}} ارسال شد.',
            paymentFailed: 'پرداخت انجام نشد. صندلی‌های شما تا ساعت {{time}} نگه داشته می‌شود.',
            paymentFailedExpired: 'پرداخت انجام نشد و مهلت رزرو به پایان رسیده است.',
            retryPayment: 'پرداخت دوباره',
            ticketNumber: 'شماره بلیت',
            document: 'مدرک',
            printTicket: 'چاپ بلیت',
            newSearch: 'جستجوی جدید',
            amountPaid: 'مبلغ پرداخت‌شده',
            primaryNav: 'منوی اصلی',
            openMenu: 'باز کردن منو',
            closeMenu: 'بستن منو',
            swapRoute: 'جابه‌جایی مبدا و مقصد',
            originCity: 'مبدا (شهر)',
            destinationCity: 'مقصد (شهر)',
            searchCity: 'جستجوی شهر یا کد فرودگاه',
            noCityResults: 'شهری با این جستجو پیدا نشد.',
            calendarToday: 'امروز',
            calendarPrevMonth: 'ماه قبل',
            calendarNextMonth: 'ماه بعد',
            child: 'کودک',
            infant: 'نوزاد',
            refundable: 'قابل استرداد',
            nonRefundable: 'غیرقابل استرداد',
            fareClass: 'کلاس نرخی',
            baggage: 'بار مجاز',
            refundRules: 'جریمه کنسلی',
            fareChecking: 'در حال استعلام قیمت از ایرلاین…',
            fareUnavailable: 'این نرخ دیگر موجود نیست. لطفاً پرواز دیگری انتخاب کنید.',
            mixNoAdult: 'حداقل یک بزرگسال (۱۲ سال به بالا) باید همراه باشد.',
            mixTooManyInfants: 'هر نوزاد باید همراه یک بزرگسال باشد.',
            mixTooManyDependants: 'هر بزرگسال حداکثر می‌تواند ۴ کودک و نوزاد همراه داشته باشد.',
            priceChanged: 'قیمت ایرلاین از {{old}} به {{amount}} تغییر کرد.',
            payNewPrice: 'ادامه و پرداخت {{amount}}',
            airlineReference: 'کد رزرو ایرلاین',
            ticketing: 'پرداخت انجام شد. در حال صدور بلیت…',
            ticketingLead: 'این کار معمولاً کمتر از یک دقیقه طول می‌کشد. می‌توانید این صفحه را باز نگه دارید.',
            ticketingDelayed: 'صدور بلیت بیش از حد معمول طول کشیده است. همکاران ما پیگیری می‌کنند و به {{email}} اطلاع می‌دهند.',
            refundNotice: 'پرداخت شما انجام شد اما رزرو تکمیل نشد. کل مبلغ به کارت شما بازگردانده می‌شود.',
            bookingCancelled: 'این رزرو لغو شده است.',
            bookingStatus: {
                HOLD: 'رزرو موقت',
                TICKETING: 'در حال صدور بلیت',
                CONFIRMED: 'قطعی',
                CANCELLED: 'لغو شده',
                EXPIRED: 'منقضی شده',
                COMPLETED: 'انجام شده',
            },
            nrsReasons: {
                CLASS_CLOSED: 'ظرفیت این نرخ همین حالا تکمیل شد. لطفاً پرواز دیگری انتخاب کنید.',
                FOREIGN_NATIONAL_CLASS: 'این نرخ مخصوص مسافران خارجی است.',
                INVALID_DOCUMENT: 'ایرلاین مدرک یکی از مسافران را نپذیرفت. کد ملی یا اطلاعات گذرنامه را بررسی کنید.',
                INVALID_NAME: 'ایرلاین نام یکی از مسافران را نپذیرفت. نام را با حروف لاتین مطابق گذرنامه وارد کنید.',
                INVALID_CONTACT: 'ایرلاین شماره موبایل را نپذیرفت.',
                PASSENGER_MIX: 'کودک و نوزاد باید همراه بزرگسال سفر کنند.',
                PASSENGER_NOT_ALLOWED: 'ایرلاین یکی از مسافران را برای این پرواز نمی‌پذیرد.',
                PNR_CANCELLED: 'رزرو توسط ایرلاین لغو شد.',
                PRICE_MISMATCH: 'قیمت در ایرلاین تغییر کرده است. لطفاً دوباره جستجو کنید.',
                OTHER: 'ایرلاین این رزرو را نپذیرفت. لطفاً پرواز دیگری را امتحان کنید.',
            },
            apiErrors: {
                NRS_UNAVAILABLE: 'سامانه ایرلاین در حال حاضر در دسترس نیست. چند دقیقه دیگر دوباره تلاش کنید.',
                FLIGHT_CHANGED: 'زمان پرواز تغییر کرده است. لطفاً دوباره جستجو کنید.',
                RATE_LIMITED: 'تعداد تلاش‌ها زیاد است. چند دقیقه صبر کنید و دوباره تلاش کنید.',
                VALIDATION_ERROR: 'برخی از اطلاعات مسافران معتبر نیست. لطفاً بررسی کنید.',
            },
        },
        nav: {
            login: 'ورود/ثبت‌نام',
            missing: 'این صفحه پیدا نشد.',
            groups: {
                book: 'رزرو',
                travelInfo: 'اطلاعات سفر',
                inflight: 'در طول پرواز',
                destinations: 'مقاصد پروازی',
            },
            items: {
                buyTicket: 'خرید بلیت',
                checkin: 'پذیرش آنلاین',
                refund: 'استرداد بلیت',
                change: 'تغییر بلیت',
                transfer: 'ترانسفر فرودگاهی',
                buyGuide: 'راهنمای خرید بلیت',
                manageGuide: 'راهنمای مدیریت رزرو',
                refundGuide: 'راهنمای استرداد بلیت',
                checkinGuide: 'راهنمای پذیرش مسافر',
                reduced: 'مسافر توان‌خواه',
                medical: 'موارد پزشکی',
                minor: 'کودک بدون همراه',
                meals: 'خوراک ویژه',
                lounge: 'خدمات لانج',
                requirements: 'شرایط سفر به کشورها',
                baggage: 'بار مسافر',
                dangerous: 'کالاهای ممنوعه و خطرناک',
                animals: 'حیوان زنده',
                lost: 'بار گمشده',
                safety: 'ایمنی و امنیت پرواز',
                fleet: 'ناوگان سروش',
                seats: 'وضعیت صندلی‌ها',
                cabins: 'کلاس‌های پروازی',
                crew: 'کروی پروازی',
                dining: 'پذیرایی',
                entertainment: 'سرگرمی‌های داخل پرواز',
                magazine: 'مجله پروازی',
                domestic: 'مقاصد داخلی',
                international: 'مقاصد بین‌المللی',
                tourism: 'گردشگری با سروش',
                club: 'باشگاه مسافران ویژه',
            },
            leads: {
                refund: 'برای ادامه استرداد، رزرو را با کد و نام خانوادگی پیدا کنید.',
                change: 'برای ادامه تغییر بلیت، رزرو را با کد و نام خانوادگی پیدا کنید.',
            },
            copy: {
                transfer: 'ترانسفر فرودگاهی برای سفرهای منتخب بین‌المللی و کلاس بیزینس، پیش از پرواز هماهنگ می‌شود.',
                buyGuide: 'مسیر را جستجو کنید، پرواز را انتخاب کنید و مشخصات مسافر را وارد کنید. پرداخت امن، بلیت را صادر می‌کند.',
                manageGuide: 'با کد رزرو و نام خانوادگی، وضعیت بلیت را ببینید.',
                refundGuide: 'استرداد با کد رزرو و نام خانوادگی آغاز می‌شود. جریمه طبق قوانین همان نرخ محاسبه می‌شود.',
                checkinGuide: 'پذیرش آنلاین از ۲۴ ساعت قبل از پرواز باز می‌شود. کد رزرو، نام خانوادگی و شماره پرواز لازم است.',
                reduced: 'مسافر توان‌خواه می‌تواند ویلچر یا همراهی در فرودگاه را پیش از سفر درخواست کند.',
                medical: 'نیازهایی مانند اکسیژن یا برانکارد را پیش از صدور بلیت با ایرلاین هماهنگ کنید.',
                minor: 'کودک بدون همراه با رضایت سرپرست سفر می‌کند و در مبدا و مقصد تحویل داده می‌شود.',
                meals: 'خوراک ویژه را هنگام رزرو، یا دست‌کم ۲۴ ساعت قبل از پرواز، درخواست کنید.',
                lounge: 'سالن پذیرایی برای کلاس بیزینس و اعضای باشگاه، در فرودگاه‌های منتخب در دسترس است.',
                requirements: 'ویزا و قوانین ورود بر عهده مسافر است. پیش از سفر، شرایط مقصد را بررسی کنید.',
                baggage: 'بار مجاز به کلاس و نرخ بلیت بستگی دارد. بار اضافی در فرودگاه محاسبه می‌شود.',
                dangerous: 'مایعات، باتری و کالاهای خطرناک ممکن است در کابین یا بار تحویلی محدودیت داشته باشند.',
                animals: 'حمل حیوان زنده فقط با هماهنگی قبلی و قفس مورد تایید ممکن است.',
                lost: 'اگر بار به مقصد نرسید، همان روز در دفتر بار فرودگاه گزارش دهید و کد رزرو را همراه داشته باشید.',
                safety: 'کمربند ایمنی، خروجی‌های اضطراری و دستور خدمه، مبنای ایمنی در طول پرواز است.',
                fleet: 'ناوگان سروش شبکه پروازهای داخلی و بین‌المللی را پوشش می‌دهد.',
                seats: 'چیدمان صندلی با نوع هواپیما فرق می‌کند. انتخاب صندلی با پذیرش آنلاین باز می‌شود.',
                cabins: 'اکونومی و بیزینس در بار، پذیرایی و فضای صندلی با هم فرق دارند.',
                crew: 'کروی پروازی مسئول ایمنی کابین و پذیرایی در طول پرواز است.',
                dining: 'پذیرایی بر اساس مدت پرواز و کلاس انتخاب‌شده ارائه می‌شود.',
                entertainment: 'سرگرمی داخل پرواز در مسیرهای منتخب در دسترس است.',
                magazine: 'مجله پروازی سروش در پروازهای منتخب عرضه می‌شود.',
                tourism: 'ایده‌های سفر در شبکه داخلی و بین‌المللی سروش.',
                domestic: 'شهرهایی که سروش در ایران به آن‌ها پرواز می‌کند.',
                international: 'شهرهایی که سروش بیرون از ایران به آن‌ها پرواز می‌کند.',
                club: 'باشگاه مسافران ویژه، مایل‌ها، سطح عضویت و شماره عضویت را نگه می‌دارد.',
            },
        },
        fleet: {
            specsTitle: 'مشخصات فنی',
            specs: {
                mtow: 'حداکثر وزن برخاست',
                range: 'حداکثر برد',
                wingspan: 'طول بال',
                length: 'طول هواپیما',
                height: 'ارتفاع هواپیما',
                passengers: 'ظرفیت مسافر',
            },
            units: {
                kg: 'کیلوگرم',
                km: 'کیلومتر',
                m: 'متر',
                pax: 'نفر',
            },
            a300: {
                name: 'ایرباس A300-600',
            },
            a310: {
                name: 'ایرباس A310',
            },
        },
        club: {
            eyebrow: 'باشگاه سروش',
            title: 'عضویت شما',
            lead: 'مایل‌ها، سطح عضویت، و مشخصات مسافری که در پرواز استفاده می‌کنیم.',
            member: 'عضو',
            awardMiles: 'مایل قابل استفاده',
            lifetime: 'کل مایل‌ها',
            statusMiles: 'مایل وضعیت',
            segments: 'پرواز',
            tierUntil: 'بازنگری سطح تا {{date}}',
            milesToNext: '{{miles}} مایل تا {{tier}}',
            topTier: 'بالاترین سطح عضویت',
            benefits: {
                BLUE: 'با هر پرواز سروش مایل بگیرید.',
                SILVER: 'با رسیدن به نقره‌ای، پذیرش اولویت‌دار دارید.',
                GOLD: 'بار اضافه و دسترسی به لانژ در فرودگاه‌های منتخب.',
                PLATINUM: 'خدمات اختصاصی و بالاترین اولویت در فرودگاه.',
            },
            completeTitle: 'مدارک سفر را تکمیل کنید',
            completeLead: 'این مشخصات در باشگاه می‌ماند و در رزرو بعدی‌تان پر می‌شود.',
            completeAction: 'تکمیل مشخصات',
            profile: 'مشخصات مسافر',
            edit: 'ویرایش',
            save: 'ذخیره مشخصات',
            upcoming: 'پروازهای پیش رو',
            past: 'سابقه پرواز',
            activity: 'گردش مایل',
            emptyFlights: 'هنوز پروازی نیست. رزروی که با حساب خود انجام دهید اینجا دیده می‌شود.',
            emptyActivity: 'مایل‌ها پس از صدور بلیت اینجا ثبت می‌شوند.',
            noMiles: 'مایل پس از صدور بلیت محاسبه می‌شود.',
            signInLead: 'برای دیدن مایل، سطح عضویت و سفرها وارد شوید.',
            landing: {
                heroEyebrow: 'باشگاه مسافران وفادار سروش',
                heroTitle: 'به باشگاه سروش بپیوندید و با اعتبار پرواز کنید',
                heroLead: 'عضویت، مایل هر پرواز سروش، مزایای سطح در فرودگاه، و مسیر روشن تا نقره‌ای، طلایی و پلاتینیوم را برای شما باز می‌کند.',
                joinCta: 'ورود | ثبت‌نام',
                seeBenefits: 'مشاهده مزایا و امکانات',
                welcomeTitle: 'مایل‌هایی که هر سفر را به یاد می‌سپارند',
                welcomeLead: 'یک‌بار حساب بسازید؛ بعد با هر پرواز مایل بگیرید، پیشرفت سطح را ببینید و از خدمات باشگاه استفاده کنید.',
                tiersTitle: 'رده‌های عضویت',
                tiersLead: 'ساختار رده‌بندی عضویت در باشگاه مسافران وفادار سروش، با هدف ارائه خدمات متناسب با میزان همراهی هر مسافر طراحی شده است. این رده‌بندی شامل چهار سطح آبی، نقره‌ای، طلایی و پلاتینیوم است.',
                tiersVisualAlt: 'کارت‌های عضویت باشگاه سروش برای سطوح آبی، نقره‌ای، طلایی و پلاتینیوم',
                fromMiles: 'از {{miles}} مایل',
                tierNames: {
                    BLUE: 'آبی',
                    SILVER: 'نقره‌ای',
                    GOLD: 'طلایی',
                    PLATINUM: 'پلاتینیوم',
                },
                servicesTitle: 'خدمات باشگاه',
                services: {
                    miles: {
                        title: 'کسب و استفاده از مایل',
                        lead: 'با پروازهای سروش مایل بگیرید و برای سفرهای بعدی از آن استفاده کنید.',
                    },
                    baggage: {
                        title: 'اضافه بار',
                        lead: 'در سطوح بالاتر، امکان حمل بار بیشتر در مسیرهای منتخب فراهم است.',
                    },
                    lounge: {
                        title: 'سالن پذیرایی',
                        lead: 'اعضای طلایی و پلاتینیوم در فرودگاه‌های منتخب به لانژ دسترسی دارند.',
                    },
                    priority: {
                        title: 'اولویت در فرودگاه',
                        lead: 'با ارتقای سطح، پذیرش سریع‌تر و خدمات اختصاصی‌تری دریافت می‌کنید.',
                    },
                },
                finalTitle: 'آماده شروع هستید؟',
                finalLead: 'عضویت بسازید یا وارد شوید تا مایل، پیشرفت سطح و سفرهایتان را ببینید.',
            },
            localFirstName: 'نام فارسی',
            localLastName: 'نام خانوادگی فارسی',
            homeAirport: 'فرودگاه مبدأ',
            invalidAirport: 'کد سه‌حرفی فرودگاه را وارد کنید.',
            seat: 'صندلی ترجیحی',
            meal: 'وعده غذایی',
            assistance: 'خدمات ویژه',
            assistanceNone: 'ندارد',
            emergency: 'تماس اضطراری',
            emergencyName: 'نام',
            emergencyPhone: 'تلفن',
            emergencyRelation: 'نسبت',
            marketing: 'خبرها و پیشنهادهای باشگاه را برایم بفرستید',
            preferences: 'ترجیح‌های سفر',
            documents: 'مدارک',
            contact: 'راه‌های ورود',
            contactHint: 'با هر کدام از این‌ها می‌توانید وارد شوید.',
            reasons: { FLIGHT_EARN: 'پرواز' },
            seats: { ANY: 'فرقی ندارد', WINDOW: 'پنجره', AISLE: 'راهرو' },
            meals: {
                STANDARD: 'معمولی',
                VEGETARIAN: 'گیاهی',
                HALAL: 'حلال',
                KOSHER: 'کوشر',
                CHILD: 'کودک',
            },
            assistanceCodes: {
                WCHR: 'ویلچر تا گیت',
                WCHS: 'ویلچر روی پله',
                WCHC: 'ویلچر تا صندلی',
                DEAF: 'مسافر ناشنوا',
                BLND: 'مسافر نابینا',
                MAAS: 'استقبال و همراهی',
            },
            status: {
                HOLD: 'رزرو موقت',
                TICKETING: 'در حال صدور',
                CONFIRMED: 'قطعی',
                CANCELLED: 'لغو شده',
                COMPLETED: 'انجام شده',
                EXPIRED: 'منقضی',
            },
        },
        auth: {
            welcome: 'خوش آمدید',
            welcomeLead: 'با موبایل یا ایمیل خود وارد شوید. اگر هنوز ثبت‌نام نکرده‌اید، از همین‌جا عضو شوید.',
            email: 'ایمیل',
            identifier: 'موبایل یا ایمیل',
            invalidIdentifier: 'شماره موبایل یا ایمیل را وارد کنید.',
            password: 'رمز عبور',
            passwordHint: 'حداقل ۱۰ نویسه، با حرف بزرگ و کوچک، عدد و یک نماد.',
            firstName: 'نام',
            latinHint: 'همان‌طور که روی گذرنامه یا کارت شناسایی، با حروف انگلیسی.',
            altEmail: 'ایمیل (اختیاری)',
            altMobile: 'موبایل (اختیاری)',
            otherContact: 'مورد دیگر را هم اضافه کنید تا با هر دو بتوانید وارد شوید.',
            needContact: 'شماره موبایل یا ایمیل را وارد کنید.',
            noAccount: 'حساب ندارید؟',
            hasAccount: 'قبلاً عضو شده‌اید؟',
            signIn: 'ورود',
            join: 'عضویت',
        },
        admin: {
            brand: 'سروش',
            console: 'پنل مدیریت',
            rial: 'ریال',
            empty: 'موردی برای نمایش وجود ندارد.',
            nav: {
                dashboard: 'داشبورد',
                flights: 'پروازها',
                routeFares: 'نرخ مسیرها',
                bookings: 'رزروها',
                users: 'کاربران',
                audit: 'گزارش رویدادها',
                nrsRest: 'نرخ‌های NRS',
                signOut: 'خروج',
            },
            login: {
                email: 'ایمیل',
                password: 'رمز عبور',
                signIn: 'ورود',
                roleRequired: 'این حساب دسترسی مدیریت ندارد.',
                invalidCredentials: 'ایمیل یا رمز عبور نادرست است.',
            },
            dashboard: {
                title: 'داشبورد عملیات',
                integrations: 'اتصال‌ها',
                nira: 'سرویس نیرا',
                paymentGateway: 'درگاه پرداخت',
                connected: 'متصل',
                notConnected: 'در دسترس نیست',
                notConfigured: 'تنظیم نشده',
                configured: 'تنظیم شده',
                nrs: 'سامانه رزرو NRS',
                nrsSales: 'فروش آنلاین NRS',
                nrsCredit: 'اعتبار آفیس',
                nrsBlocked: 'مسدود',
                nrsRest: 'API جدید NRS (FareQuote / MultiSeg)',
                salesOn: 'فعال',
                salesOff: 'غیرفعال (برنامه پروازی و نرخ مسیرها)',
                stats: {
                    bookings: 'کل رزروها',
                    completedPayments: 'پرداخت‌های موفق',
                    users: 'کاربران',
                    activeFlights: 'پروازهای فعال',
                    holds: 'در انتظار پرداخت',
                    confirmed: 'رزروهای قطعی',
                    ticketing: 'پرداخت‌شده، در انتظار صدور',
                    refundPending: 'استردادهای قابل پرداخت',
                },
                gateways: {
                    MOCK: 'آزمایشی',
                    SAMAN: 'سامان',
                },
            },
            flights: {
                title: 'پروازها',
                flightNumber: 'شماره پرواز',
                origin: 'مبدا',
                destination: 'مقصد',
                departure: 'زمان حرکت',
                create: 'ثبت پرواز',
                flight: 'پرواز',
                route: 'مسیر',
                status: 'وضعیت',
            },
            routeFares: {
                title: 'نرخ مسیرها',
                lead: 'قیمت و تعداد صندلی هر پرواز برای مسیرهای برنامه پروازی NRS. تا زمانی که NRS نرخ و ظرفیت لحظه‌ای ارائه دهد، از این مقادیر استفاده می‌شود.',
                origin: 'مبدا',
                destination: 'مقصد',
                cabin: 'کلاس پروازی',
                baseFare: 'نرخ پایه (ریال)',
                taxes: 'مالیات و عوارض (ریال)',
                seatsPerFlight: 'صندلی در هر پرواز',
                onSale: 'قابل فروش',
                off: 'غیرفعال',
                save: 'ذخیره نرخ',
                saving: 'در حال ذخیره…',
                unpriced: 'مسیرهای در حال فروش بدون نرخ:',
                route: 'مسیر',
                baseFareShort: 'نرخ پایه',
                taxesShort: 'مالیات و عوارض',
                total: 'مجموع',
                seats: 'صندلی / پرواز',
                status: 'وضعیت',
                edit: 'ویرایش',
                delete: 'حذف',
            },
            bookings: {
                title: 'رزروها',
                pnr: 'کد رزرو',
                status: 'وضعیت',
                total: 'مبلغ کل',
                email: 'ایمیل',
                airlinePnr: 'PNR ایرلاین',
                flight: 'پرواز',
                created: 'زمان ثبت',
                search: 'کد رزرو، PNR ایرلاین، ایمیل یا شماره بلیت',
                searchButton: 'جستجو',
                open: 'جزئیات',
            },
            bookingDetail: {
                back: 'همه رزروها',
                title: 'رزرو {{pnr}}',
                summary: 'خلاصه',
                source: 'منبع',
                sources: { local: 'موجودی داخلی', nrs: 'NRS (آنلاین)' },
                contact: 'اطلاعات تماس',
                flight: 'پرواز',
                fareClass: 'کلاس نرخی',
                baggage: 'بار مجاز',
                refundable: 'قابل استرداد',
                yes: 'بله',
                no: 'خیر',
                holdUntil: 'پایان مهلت رزرو',
                passengers: 'مسافران',
                name: 'نام',
                type: 'رده سنی',
                document: 'مدرک',
                ticket: 'بلیت',
                passengerTypes: { ADT: 'بزرگسال', CHD: 'کودک', INF: 'نوزاد' },
                payments: 'پرداخت‌ها',
                amount: 'مبلغ',
                refundAmount: 'مبلغ قابل استرداد',
                paidAt: 'زمان پرداخت',
                gateway: 'درگاه',
                note: 'توضیح',
                ticketing: 'صدور بلیت',
                attempts: 'تعداد تلاش',
                lastError: 'آخرین خطا',
                nextAttempt: 'تلاش خودکار بعدی',
                manual: 'نیازمند اقدام دستی',
                issueNow: 'صدور بلیت',
                abandon: 'لغو PNR و استرداد',
                abandonConfirm: 'PNR ایرلاین لغو و پرداخت برای استرداد علامت‌گذاری شود؟',
                airline: 'اطلاعات زنده ایرلاین',
                loadAirline: 'دریافت PNR و بلیت‌ها از NRS',
                pnrStatus: 'وضعیت PNR',
                airlineTotal: 'مبلغ کل ایرلاین',
                coupons: 'کوپن‌ها',
                refund: 'استرداد',
                previewPenalty: 'بررسی جریمه',
                penaltyNow: 'جریمه در این لحظه',
                refundNow: 'مبلغ قابل استرداد',
                maxPenalty: 'حداکثر جریمه',
                skipSeatCancel: 'صندلی‌ها قبلاً آزاد شده‌اند (پس از بسته شدن پذیرش)',
                refundSelected: 'استرداد مسافران انتخاب‌شده',
                refundConfirm: 'صندلی‌ها لغو و بلیت‌های انتخاب‌شده در ایرلاین استرداد شوند؟ این کار برگشت‌پذیر نیست.',
                refundDone: 'استرداد در ایرلاین ثبت شد: {{amount}}. مبلغ را از پنل درگاه به مسافر برگردانید.',
                refunded: 'استرداد شده',
                refundedAmount: 'مبلغ استرداد',
                penalty: 'جریمه',
                working: 'در حال انجام…',
            },
            paymentStatus: {
                PENDING: 'در انتظار',
                REDIRECTED: 'در درگاه',
                COMPLETED: 'پرداخت شده',
                FAILED: 'ناموفق',
                REFUND_PENDING: 'در انتظار استرداد',
                REFUNDED: 'مسترد شده',
            },
            users: {
                title: 'کاربران',
                email: 'ایمیل',
                name: 'نام',
                role: 'نقش',
                active: 'فعال',
                yes: 'بله',
                no: 'خیر',
            },
            nrsRest: {
                title: 'نرخ و ظرفیت NRS',
                lead: 'بررسی فقط‌خواندنی سرویس REST سیستم NRS: ظرفیت و قیمت چندقطعه‌ای (MultiSegAYFare) و استعلام دقیق نرخ پروازهای انتخاب‌شده (FareQuote). مبالغ دقیقاً همان‌گونه که NRS برمی‌گرداند نمایش داده می‌شوند.',
                availabilityTitle: 'ظرفیت چندقطعه‌ای',
                quoteTitle: 'استعلام نرخ',
                origin: 'مبدا',
                destination: 'مقصد',
                date: 'تاریخ',
                flightClass: 'کلاس رزرو',
                flightNo: 'شماره پرواز',
                adults: 'بزرگسال',
                children: 'کودک',
                infants: 'نوزاد',
                includePrice: 'نمایش قیمت',
                currency: 'ارز (اختیاری)',
                discountCode: 'کد تخفیف',
                salesDate: 'تاریخ فروش (فقط RC/FSP)',
                addSegment: 'افزودن قطعه',
                removeSegment: 'حذف',
                search: 'جستجو',
                quote: 'استعلام نرخ',
                running: 'در حال انجام…',
                noItineraries: 'مسیری پیدا نشد.',
                unpriced: 'ظرفیت دارد، نرخ محاسبه نشد',
                connection: 'پرواز ارتباطی',
                cabin: 'کلاس پروازی',
                bookingClasses: 'کلاس‌های رزرو',
                passenger: 'مسافر',
                fare: 'نرخ پایه',
                taxes: 'مالیات و عوارض',
                total: 'جمع',
                baggage: 'بار',
                coupon: 'قطعه',
                premium: 'P = پریمیوم اکونومی',
            },
            audit: {
                title: 'گزارش رویدادها',
                action: 'عملیات',
                resource: 'بخش',
                result: 'نتیجه',
                when: 'زمان',
                ok: 'موفق',
                fail: 'ناموفق',
            },
            cabins: {
                economy: 'اقتصادی',
                premium_economy: 'پریمیوم اکونومی',
                business: 'تجاری',
                first: 'درجه یک',
            },
            bookingStatus: {
                HOLD: 'در انتظار پرداخت',
                TICKETING: 'پرداخت‌شده، در حال صدور',
                CONFIRMED: 'قطعی',
                CANCELLED: 'لغو شده',
                COMPLETED: 'انجام شده',
                EXPIRED: 'منقضی شده',
            },
            flightStatus: {
                SCHEDULED: 'برنامه‌ریزی شده',
                BOARDING: 'در حال سوار شدن',
                DEPARTED: 'پرواز کرده',
                ARRIVED: 'نشسته',
                CANCELLED: 'لغو شده',
                DELAYED: 'با تأخیر',
            },
            roles: {
                customer: 'مسافر',
                admin: 'مدیر',
                superadmin: 'مدیر ارشد',
            },
            actions: {
                LOGIN: 'ورود',
                LOGIN_FAILED: 'ورود ناموفق',
                LOGOUT: 'خروج',
                REGISTER: 'ثبت‌نام',
                CREATE: 'ایجاد',
                UPDATE: 'ویرایش',
                DELETE: 'حذف',
                PAYMENT: 'پرداخت',
                RECONCILE: 'تطبیق',
            },
            resources: {
                airport: 'فرودگاه',
                booking: 'رزرو',
                flight: 'پرواز',
                payment: 'پرداخت',
                routeFare: 'نرخ مسیر',
                user: 'کاربر',
            },
            errors: {
                UNAUTHORIZED: 'نشست شما به پایان رسیده است. دوباره وارد شوید.',
                FORBIDDEN: 'اجازه دسترسی به این بخش را ندارید.',
                NOT_FOUND: 'مورد درخواستی پیدا نشد.',
                CONFLICT: 'این عملیات با اطلاعات موجود تداخل دارد.',
                VALIDATION_ERROR: 'برخی از مقادیر واردشده معتبر نیست.',
                RATE_LIMITED: 'تعداد درخواست‌ها زیاد است. کمی بعد دوباره تلاش کنید.',
                NRS_REJECTED: 'ایرلاین درخواست را نپذیرفت.',
                NRS_UNAVAILABLE: 'سامانه ایرلاین در حال حاضر در دسترس نیست.',
                NRS_REFUND_INCOMPLETE: 'استرداد نیمه‌کاره متوقف شد. وضعیت مسافران را بررسی کنید.',
                NRS_TICKET_MISMATCH: 'بلیت‌ها با مسافران مطابقت نداشت. PNR را در NRS بررسی کنید.',
                NRS_PASSENGER_NOT_FOUND: 'مسافر در PNR ایرلاین پیدا نشد.',
                FLIGHT_CHANGED: 'زمان پرواز در ایرلاین تغییر کرده است.',
                generic: 'خطایی رخ داد. دوباره تلاش کنید.',
            },
        },
    },
};
export function isRtlLocale(locale) {
    return locale === 'fa';
}
//# sourceMappingURL=index.js.map